import IconButton from 'components/common/IconButton';
import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ButtonEdit = ({
  funcion,
  data,
  disabled,
  text,
  className,
  justify,
  style,
  tooltipPosition
}) => {
  return text ? (
    <Button
      className={
        className + ' d-flex align-items-center justify-content-center'
      }
      variant={!disabled ? 'light' : 'secondary'}
      size="sm"
      disabled={disabled}
      onClick={data ? () => funcion(data) : funcion}
      type="submit"
      style={{ cursor: disabled ? 'not-allowed' : 'pointer', ...style }}
    >
      <div
        className={`w-100 d-flex align-items-center justify-content-${justify} gap-1`}
      >
        <FontAwesomeIcon icon="fa-pen-to-square" style={{ marginRight: 5 }} />
        <span style={{ marginRight: 10 }}>{text}</span>
      </div>
    </Button>
  ) : (
    <OverlayTrigger
      placement={tooltipPosition || 'bottom'}
      overlay={<Tooltip>Editar</Tooltip>}
    >
      <span>
        <IconButton
          buttonSize="sm"
          style={{ width: 30, ...style }}
          icon="fa-pen-to-square"
          onClick={
            !disabled ? (data ? () => funcion(data) : funcion) : () => {}
          }
          variant="light"
          className={className + ' px-2'}
          disabled={disabled}
        />
      </span>
    </OverlayTrigger>
  );
};

ButtonEdit.propTypes = {
  funcion: PropTypes.func.isRequired,
  data: PropTypes.any,
  disabled: PropTypes.bool,
  text: PropTypes.string,
  className: PropTypes.string,
  justify: PropTypes.oneOf(['start', 'center', 'end']),
  style: PropTypes.object,
  tooltipPosition: PropTypes.oneOf(['top', 'right', 'bottom', 'left'])
};

ButtonEdit.defaultProps = {
  justify: 'center'
};

export default ButtonEdit;
